// utils/inputUtils.js

/**
 * Sanitize input to allow only alphanumeric (letters + numbers),
 * and limit to 10 characters.
 *
 * @param {string} input
 * @param {number} maxLen
 * @returns {string}
 */
export const sanitizeAlphanumericLimit = (input, maxLen = 10) => {
  return input.replace(/[^a-zA-Z0-9]/g, "").slice(0, maxLen);
};

// This allows only alphanumeric characters and spaces
export const sanitizeStrictAlphanumeric = (input) => {
  const isValid = /^[a-zA-Z0-9\s]*$/.test(input);
  if (!isValid) return "";
  return input;
};